<template lang="pug">
AppSelect(
  v-model="selected"
  :options="ACTIVITY_TIME_TYPE_FILTERS"
  :select2-options="select2Options"
)
</template>

<script>
import { ACTIVITY_TIME_TYPE_FILTERS } from '~/app_constants';

export default {
  name: 'ActivitiesTimeTypeFilter',
  props: {
    value: {
      type: [String, Number],
    },
  },
  data: () => ({
    ACTIVITY_TIME_TYPE_FILTERS,
    select2Options: {
      allowClear: true,
      multiple: false,
      width: '100%',
      placeholder: 'All types',
    },
  }),
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(activityLevel) {
        this.$emit('input', activityLevel);
      },
    },
  },
};
</script>
